export const SECTION_HEADING_CLASS =
    "text-2xl md:text-4xl font-bold uppercase font-Montserrat text-Heading_Black text-center";
